<sh-table
  *ngIf="configuration?.length"
  tableId="ui-module-field-configuration"
  density="compact"
  dataKey="field"
  [columns]="columns"
  [rows]="configuration ?? []"
  [rowActions]="rowActions"
>
  <ng-template shCell="subDisplayFields" let-row>
    <sh-input
      ariaLabel="uiModules.displayedFields"
      [(value)]="row.subDisplayFields"
    ></sh-input>
  </ng-template>
  <ng-template shCell="sortField" let-row>
    <sh-number
      ariaLabel="uiModules.sorting"
      [(value)]="row.sortField"
    ></sh-number>
  </ng-template>
  <ng-template shCell="columnName" let-row>
    <sh-input
      ariaLabel="uiModules.columnName"
      [(value)]="row.columnName"
    ></sh-input>
  </ng-template>
</sh-table>
